import { HTMLChakraProps, forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { useThinkingContext } from '../ThinkingContext';
import { useThinkingStyles } from '../useThinkingStyles';

export type ThinkingLabelProps = HTMLChakraProps<'p'>;

export const ThinkingLabel: React.FC<ThinkingLabelProps> = forwardRef<
  ThinkingLabelProps,
  'p'
>(({ children, ...props }, ref) => {
  const { label } = useThinkingStyles();
  const { isExpanded, isThinking, isToggleExpansionDisabled, setIsExpanded } =
    useThinkingContext();

  return (
    <chakra.p
      sx={label}
      className="thinking-label"
      onClick={
        !isToggleExpansionDisabled
          ? () => setIsExpanded(!isExpanded)
          : undefined
      }
      // Apply attributes in relevant states to connect to styles.
      data-thinking={isThinking}
      data-can-expand={!isToggleExpansionDisabled}
      {...props}
      ref={ref}
    >
      {children}
    </chakra.p>
  );
});
